export default class TrustindexFomoWidget {
	constructor(widget)
	{
		this.widget = widget;
		this.fomoDay = parseInt(this.widget.getAttribute('data-fomo-day') || '0');
		this.hideCount = parseInt(this.widget.getAttribute('data-hide-count') || '0');
		this.siteData = {};
		this.isOnlineVisitors = false;

		let meta = document.querySelector('meta[name="ti-site-data"]');
		if (meta) {
			this.siteData = JSON.parse(atob(meta.getAttribute("content").trim()));
			this.siteData.r = Object.fromEntries((this.siteData.r ?? "").split('!').map(pair => pair.split(':').map(Number)));
		}
	}

	format()
	{
		let titleText = this.widget.querySelector('.ti-title-text');
		if (titleText && -1 !== titleText.innerText.indexOf('%registrations%')) {
			let count = (this.siteData?.r?.[this.fomoDay] ?? 0);
			titleText.innerHTML = titleText.innerText.replace('%registrations%', '<span class="ti-fomo-count">'+count+'</span>');
		}

		if (titleText && -1 !== titleText.innerText.indexOf('%online-visitors%')) {
			this.isOnlineVisitors = true;
			titleText.innerHTML = titleText.innerText.replace('%online-visitors%', '<span class="ti-fomo-count">0</span>');

			this.refreshOnlineUsers();
		}

		if (this.hideCount && !Trustindex.isAdminUrl() && !Trustindex.isWordpressAdminUrl() && !Trustindex.isTestWidgetUrl()) {
			let countElement = this.widget.querySelector('.ti-fomo-count');
			if (!countElement || parseInt(countElement.innerText) < this.hideCount) {
				if (this.isOnlineVisitors) {
					Trustindex.hide(this.widget);
				} else {
					this.widget.remove();
				}
			}
		}
	}

	refreshOnlineUsers()
	{
		let url = Trustindex.getDecodedHtml(this.siteData.o ?? "");
		if (!url) {
			return;
		}

		let element = this.widget.querySelector('.ti-fomo-count');
		if (!element) {
			return;
		}

		if (this.refreshOnlineUsersInterval) {
			clearInterval(this.refreshOnlineUsersInterval);
		}

		this.getOnlineUsers(element, url);
		this.refreshOnlineUsersInterval = setInterval(() => this.getOnlineUsers(element, url), 1000 * 60);
	}

	getOnlineUsers(element, url)
	{
		(async () => {
			let count = 0;

			let html = await Trustindex.request(url);
			if (html) {
				count = parseInt(html);
			}

			element.innerText = count;

			if (this.hideCount && !Trustindex.isAdminUrl() && !Trustindex.isWordpressAdminUrl() && !Trustindex.isTestWidgetUrl()) {
				if (count < this.hideCount) {
					Trustindex.hide(this.widget);
				} else {
					Trustindex.show(this.widget);
				}
			}
		})();
	}

	click(event)
	{
		if (event.target.matches('.ti-header-closed .ti-header') && Trustindex.isMobileDevice()) {
			event.preventDefault();
			event.target.closest('.ti-header-closed').classList.remove('ti-header-closed');
		}
	}
};